<template>
  <main-layout>
    <div class="row my-4">
      <div class="col-lg-8 d-flex">
        <base-card class="w-100">
          <div
            v-if="!loading_career && !recommended_career.uuid"
            align="center"
          >
            <div style="max-width: 700px">
              <p class="empty-list__message-pretitle">
                Navegando podrás descubrir nuevas carreras e información muy importante sobre ellas.
              </p>
            </div>
            <img
              class="d-none d-lg-block empty-list__img"
              src="@/assets/img/empty_list.png"
            >
            <img
              class="d-lg-none"
              src="@/assets/img/empty_list_no_arrow.png"
              width="80%"
            >

            <div class="empty-list__message">
              <h4 class="empty-list__message-title">
                Selecciona una Carrera
              </h4>
              <p class="empty-list__message-text">
                Revisa las sugerencias que hay a
                <span
                  class="d-none d-lg-inline"
                >tu costado</span>
                <span class="d-lg-none">continuación</span>
                y clickea una tarjeta para conocer más.
              </p>
            </div>
          </div>
          <CareersShow
            v-else-if="!loading_career && recommended_career.uuid"
            :key="comp_key"
            :career-uuid="recommended_career.uuid"
            :career-id="recommended_career.id"
            :ui-config="recommended_career.visualization_type"
            :suggestion-id="recommended_career.suggestion_id"
            :answered-quiz="recommended_career.answered_quiz"
            :answer-question="answer_question"
            @toggle-favorites="toggleFavorites"
          />
          <CareerPlaceholder v-else />
        </base-card>
      </div>
      <div class="col-lg-4">
        <h4>
          <img :src="require('@/assets/group_17.png')">
          Hemos encontrado algunas opciones que te pueden interesar.
        </h4>
        <div
          v-if="loading_recommendations"
          class="recommendation-card__row"
        >
          <div
            v-for="n in 4"
            :key="n"
            class="recommendation-card__col"
          >
            <RecommendationCardPlaceholder />
          </div>
        </div>

        <div
          v-else
          class="recommendation-card__row"
        >
          <div
            v-for="(career, index) in other_recommendations"
            :key="index"
            class="recommendation-card__col"
          >
            <RecommendationCard
              :active="recommended_career.name === career.name"
              :career="career"
              @click="openModal(career)"
            />
          </div>
        </div>
        <a
          class="text-center text-muted d-block cursor-pointer"
          @click="recommendMore"
          @click.prevent
        >
          <fa-icon
            icon="redo-alt"
            class="mr-2"
            :spin="loading_recommendations"
          />Nuevas sugerencias
        </a>

        <base-modal
          id="confirm"
          :title="''"
          :show="show_modal"
          size="sm"
          @closed="show_modal = false"
        >
          <p>¿Te gustó la carrera {{ recommended_career.name }}?</p>
          <template slot="footer">
            <base-button @click="closeModal">
              No
            </base-button>
            <base-button
              inverse
              @click="addToFavorites"
            >
              Sí
            </base-button>
          </template>
        </base-modal>
      </div>
    </div>
  </main-layout>
</template>

<script>
import $ from 'jquery';
import CONFIG from '../../config';
import CareersShow from './Show.vue';
import CareerPlaceholder from './CareerPlaceholder.vue';
import { EventBus } from '../../components/EventBus';
import RecommendationCard from './RecommendationCard.vue';
import RecommendationCardPlaceholder from './RecommendationCardPlaceholder.vue';
import { careersService, studentsService } from '../../_services';

export default {
    name: 'CareersIndex',
    components: {
        CareersShow,
        RecommendationCard,
        RecommendationCardPlaceholder,
        CareerPlaceholder,
        // EventBus,
    },
    data() {
        return {
            show_modal: false,
            recommended_career: {},
            career_to_explore: {},
            other_recommendations: [],
            comp_key: -1,
            loading_career: false,
            loading_recommendations: false,
            answer_question: true,
            goToFav: false,
        };
    },
    computed: {
        big_screen() {
            return window.innerWidth > CONFIG.responsive.minWithInfoChart;
        },
    },
    created() {
        EventBus.$on('go-to-favorites', this.goToFavorites);
    },
    mounted() {
        $('.modal').modal('hide');

        this.$nextTick(function () {
            this.loading_career = true;
            this.loading_recommendations = true;
            careersService
                .recommendCareers(
                    this.$store.getters['authentication/student_uuid'],
                )
                .then((response) => {
                    // aquí se reciben las recomendaciones
                    this.comp_key = response.data[0].id;
                    this.other_recommendations = response.data;
                })
                .finally(() => {
                    this.loading_career = false;
                    this.loading_recommendations = false;
                });
        });
    },
    methods: {
        closeModal() {
            this.show_modal = false;
            $('.modal').modal('hide');
            if (this.goToFav) {
                this.$router.push({ name: 'mis-favoritos' });
            } else {
                this.explore(this.career_to_explore);
                this.career_to_explore = {};
            }
        },
        openModalToFavorites() {
            if (this.recommended_career.starred) {
                this.show_modal = false;
                this.$router.push({ name: 'mis-favoritos' });
            } else {
                this.show_modal = true;
                $('#confirm').modal('show');
            }
        },
        openModal(career) {
            this.answer_question = false;
            if (this.recommended_career.starred) {
                this.explore(career);
            }
            if (career.name === this.recommended_career.name) {
                return;
            }
            if (this.recommended_career.name) {
                this.career_to_explore = career;
                this.show_modal = true;
            } else {
                this.explore(career);
            }
        },
        goToFavorites() {
            if (this.goToFav) {
                return;
            }
            this.goToFav = true;
            if (this.recommended_career.name) {
                this.openModalToFavorites();
            } else {
                this.$router.push({ name: 'mis-favoritos' });
            }
        },
        addToFavorites() {
            studentsService
                .postCareerPreference(
                    this.$store.getters['authentication/student_uuid'],
                    { career: this.recommended_career.id },
                )
                .then(() => {
                    this.$store.commit('authentication/addStar');

                    this.$store.dispatch('notifications/add', {
                        title: 'Nueva carrera favorita',
                        message: `Se ha agregado la carrera ${this.$options.filters.capitalize(
                            this.recommended_career.name,
                        )} a tu lista de favoritos`,
                    });
                    this.recommended_career.starred = true;
                    this.closeModal();
                });
        },
        recommendMore() {
            if (this.loading_recommendations) {
                return true;
            }
            this.loading_recommendations = true;
            careersService
                .recommendCareers(
                    this.$store.getters['authentication/student_uuid'],
                    {
                        call_brain: true,
                    },
                )
                .then((response) => {
                    // aquí se reciben las recomendaciones
                    this.recommended_career = {};
                    this.other_recommendations = response.data;
                })
                .finally(() => {
                    this.loading_recommendations = false;
                });

            return false;
        },
        explore(career) {
            window.scrollTo(0, 0);
            this.recommended_career = career;
            this.comp_key = career.id;
        },
        toggleFavorites(starred) {
            this.recommended_career.starred = starred;
        },
    },
};
</script>
<style lang="scss">
.empty-list {
    &__message {
        max-width: 400px;
    }
    &__message-title {
        font-weight: bold;
        font-size: 2rem;
        color: #484c55;
    }
    &__message-text {
        font-size: 1.2rem;
        line-height: 1.2;
        color: #484c55;
    }
    &__img {
        max-width: 600px;
        margin: 0 auto;
    }
    @media (max-width: 600px){
      &__message-pretitle{
        font-size: 1.5rem;
        color: darkblue;
      }
    }
    @media (min-width: 601px){
      &__message-pretitle{
        font-size: 2.1rem;
        color: darkblue;
      }
    }
}
.recommendation-card__row {
    @media (min-width: 750px) {
        display: flex;
        flex-wrap: wrap;
        margin-left: -1rem;
    }
    @media (min-width: 992px) {
        display: block;
        margin-left: 0;
    }
}
.recommendation-card__col {
    display: flex;
    & > * {
        width: 100%;
    }

    @media (min-width: 750px) {
        flex: 0 0 50%;
        max-width: 50%;
        padding-left: 1rem;
    }

    @media (min-width: 992px) {
        flex: 0 0 100%;
        max-width: 100%;
        padding-left: 0;
    }
}
</style>
